import React, { useEffect } from 'react';
import { Row, Col, Input, Form } from 'reactstrap';
import { Controller, useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import DefaultModal from 'components/Modal/DefaultModal';
import ReactButton from 'components/Buttons/ReactButton';
import FlexSelect from 'components/Inputs/FlexSelect';

const waysOfConductingSurvey = [
  { name: 'Enviar Link', value: 'SEND_LINK' },
  { name: 'Perguntar dentro da conversa', value: 'INSIDE_CHAT_CONVERSATION' }
];

const GeneralConfigurationModal = ({
  isModalOpen,
  onModalToggle,
  fetchGeneralConfigs,
  updateGeneralConfigs,
  ...props
}) => {
  const { errors, control, handleSubmit, setValue, reset } = useForm();

  useEffect(() => {
    const loadConfigs = async () => {
      const responseData = await fetchGeneralConfigs();

      if (responseData) {
        const { data } = responseData;
        reset(data);
      }
    };

    if (isModalOpen) {
      loadConfigs();
    }
  }, [isModalOpen, reset, fetchGeneralConfigs]);

  const onSubmit = async (data) => {
    const response = await updateGeneralConfigs(data);

    if (response) {
      closeModal();
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const closeModal = () => {
    onModalToggle(false);
  };

  return (
    <>
      <DefaultModal
        show={isModalOpen}
        onModalToggle={onModalToggle}
        title="Configurações gerais da pesquisa"
        showCloseButton={false}
        modalContainerClasses="modal-lg"
        {...props}
      >
        <>
          <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
            <Row className="mb-3">
              <Col md="6">
                <label className="form-control-label">
                  Modo de realização da pesquisa*
                </label>
                <Controller
                  render={(props) => (
                    <FlexSelect
                      isClearable={false}
                      dataOptions={waysOfConductingSurvey}
                      isMulti={false}
                      closeMenuOnSelect={true}
                      value={props.value}
                      valueController={setValue}
                      fieldName="modoDeRealizarPesquisa"
                      labelName="name"
                      valueName="value"
                    />
                  )}
                  control={control}
                  name="modoDeRealizarPesquisa"
                  rules={{
                    required: 'Campo obrigatório'
                  }}
                  defaultValue=""
                />
                <ErrorMessage
                  errors={errors}
                  name="modoDeRealizarPesquisa"
                  render={({ message }) => errorFormMessage(message)}
                />
              </Col>
              <Col md="6">
                <label className="form-control-label">
                  Tempo de espera de resposta (em minutos)*
                </label>
                <Controller
                  as={<Input type="number" min={1} />}
                  control={control}
                  name="tempoDeEsperaDeResposta"
                  rules={{ required: 'Campo obrigatório!' }}
                  defaultValue=""
                />
                <ErrorMessage
                  errors={errors}
                  name="tempoDeEsperaDeResposta"
                  render={({ message }) => errorFormMessage(message)}
                />
              </Col>
            </Row>
            <hr />
            <ReactButton btnColor="confirmation" type="submit">
              Salvar
            </ReactButton>

            <ReactButton btnColor="cancelation" onClick={closeModal}>
              Cancelar
            </ReactButton>
          </Form>
        </>
      </DefaultModal>
    </>
  );
};

export default GeneralConfigurationModal;
